<template>
  <div class="dashboard__grid">
    <div class="col-left integrated">
      <user-card-container />
      <notifications-container :readonly="readonly" />
    </div>

    <div>
      <activity-container />
    </div>

    <div>
      <sales-container />
    </div>
  </div>
</template>
<script>
import UserCardContainer from '@/components/Widgets/UserCardContainer';
import ActivityContainer from '@/components/Widgets/ActivityContainer';
import SalesContainer from '@/components/Widgets/SalesContainer';
import NotificationsContainer from '@/components/Widgets/NotificationsContainer';

export default {
  components: {
    UserCardContainer,
    ActivityContainer,
    SalesContainer,
    NotificationsContainer,
  },
  computed: {
    readonly() {
      if (!this.$store.state.account.user.profile) {
        return false;
      }
      return this.$store.state.account.user.profile.ui.notify_team;
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard__grid{
  display: grid;
  gap: 0 20px;
  grid-template-columns: 1fr 210px;
  @media screen and (min-width: map-get($breakpoints,'lg')){
    grid-template-columns: minmax(200px, 270px) minmax(545px, 1fr) minmax(209px, 310px);
  }
}
.col-left.integrated{
  display: none;
  @media screen and (min-width: map-get($breakpoints,'lg')){
    display: block;
  }
}
</style>
